<footer>
  <span> ©{{ currentYear }} MOXI - Health Mobility </span>
  <a target="_blank" [href]="'global.privacyPolicyLink' | translate">
    {{ 'global.privacyPolicy' | translate }}
  </a>
  <a target="_blank" [href]="'global.termsAndConditionsLink' | translate">
    {{ 'global.termsAndConditions' | translate }}
  </a>

  @if (version()) {
    <span class="version">{{ version() }}</span>
  }
</footer>
